import { handleActions } from 'redux-actions'
import * as actions from './actions'
import { firebaseSignout } from '../signin/actions'
import omit from 'lodash/omit'

const defaultState = { encryptedNotes: {}, decryptedNotes: {} }

export default handleActions(
  {
    [actions.addNote]: (state, { payload: { key, note, decryptedNote } }) => ({
      ...state,
      encryptedNotes: { ...state.encryptedNotes, [key]: note },
      decryptedNotes: decryptedNote
        ? { ...state.decryptedNotes, [key]: decryptedNote }
        : state.decryptedNotes
    }),
    [actions.deleteNote]: (state, { payload: key }) => ({
      ...state,
      encryptedNotes: omit(state.encryptedNotes, key),
      decryptedNotes: omit(state.decryptedNotes, key)
    }),
    [actions.decryptNotesSuccess]: (state, { payload: decryptedNotes }) => ({
      ...state,
      decryptedNotes
    }),
    [firebaseSignout]: () => defaultState
  },
  defaultState
)



// WEBPACK FOOTER //
// ./src/services/notes/reducer.js